import React from 'react';
import '../../../styles/global.css';

function MarimoMusic() {
  return (
    <div className="body-container">
      <h1>marimo music</h1>
      <h4>Dec 2022</h4>
      <p>An interactive music experience made with Circuit Playground Express and Pure Data.</p>
      <p>The tempo of the music is driven by a physical interactive component, namely fabric marimo-like balls acting as capacitive touch sensors. As the audience interacts more with the marino, the music speeds up; when interaction stops, the music slows down.</p>
      <p></p>
      <p><b>Note:</b> Sadly, I did not video-record the real life audience interacting with the marimo. So, the video below only demos audio output. In other words, the music in the demo is controlled manually (i.e. clicking a 'bang' object in the Pd patch) instead of by an audience in real-time.</p>
      <div className='iframe-container'>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/_ZNqtJUcnzA?si=XSu89uX4cki3IkGd" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </div>

    </div>
  );
};

export default MarimoMusic;
